import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import {
  firstPartnerAllowedRoute,
  getOrgRelativePath,
  getPartnerUiCapabilities,
  isPartnerPathAllowed
} from 'utils/partnerUiCapabilities';

/**
 * Redirect partner iframe users away from routes blocked by Smart Monitor ui_capabilities.
 */
const PartnerCapabilityGate = () => {
  const { organizationName } = useParams();
  const location = useLocation();
  const caps = getPartnerUiCapabilities();

  if (!caps.isPartnerSession) {
    return <Outlet />;
  }

  const relative = getOrgRelativePath(location.pathname, organizationName);
  if (isPartnerPathAllowed(relative, caps)) {
    return <Outlet />;
  }

  const to = firstPartnerAllowedRoute(organizationName, caps);
  if (!to) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          No access
        </Typography>
        <Typography color="text.secondary">
          Your Smart Monitor permissions do not allow any AllWell sections for this session.
        </Typography>
      </Box>
    );
  }
  return <Navigate to={to} replace />;
};

export default PartnerCapabilityGate;
